// 文章详情页面
<template>
  <div class="art-detail">
    <!-- 标题 -->
    <p class="title">{{ info.title }}</p>
    <!-- 发布方，发布时间 -->
    <div class="infos">
      <p>发布时间：{{ info.publishDate }}</p>
      <p>发布方：{{ info.publisher }}</p>
    </div>
    <!-- 内容区域，配合富文本编辑器的类名 -->
    <div class="article" v-html="info.content" />
    <!-- 附件区域 -->
    <div class="others">
      <template v-if="fileList.length">
        <span>附件 : </span>
        <p
          v-for="(item, index) of fileList"
          :key="'others-' + index"
          @click="downLoad(item)"
        >
          {{ item.filename }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { Encrypt } from '@/utils/secret'
import fileDownload from '../../utils/fileDownload'
import {Message} from "element-ui"
export default {
  name: 'art-detail',
  data() {
    return {
      info: {
        columnName: '', // 栏目
        content: '', // 文章内容
        contentForSearch: '', // 摘要，纯文本的格式
        isTop: '0', // 是否置顶
        publishDate: '', // 发布时间
        publisher: '', // 发布方
        title: '', // 标题
        fileFullPath: '' // 文件列表，存储了一个json字符串
      },
      fileList: [], // 附件列表
      editor: null
    }
  },
  created() {
    this.selectDescInfoById()
  },
  watch: {
    $route() {
      this.selectDescInfoById()
    }
  },
  methods: {
    // 根据id，获取文章内容
    selectDescInfoById() {
      this.$api.selectDescInfoById({ id: this.$route.query.id }).then((r) => {
        this.info = r.result
        this.fileList = JSON.parse(r.result.fileFullPath)
      })
    },
    // 根据流，下载文件
    downLoad(item) {
      console.log('下载文件：且兼容ie')
      fileDownload({
        url: '/portalCenter/download',
        name: item.filename,
        params: {
          uuid: Encrypt(item.filePath),
          fileName: item.filename
        }
      }).catch((e) => {
        Message({
          message: '下载失败',
          duration: 1500,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>

.art-detail {
  padding-top: 40px;
  width: 1270px;
  margin: auto;
  .title {
    text-align: center;
    font-size: 24px;
    font-weight: bolder;
  }
  .infos {
    display: flex;
    justify-content: center;
    p {
      padding: 20px;
      color: #999999;
      font-size: 14px;
    }
  }
  .article{
    padding:20px;
    box-shadow: 3px 2px 6px 1px #e0d7d7;
    min-height: 400px;
  }
  .others {
    padding: 20px;
    span {
      // color: #999999;
      font-size: 14px;
      float: left;
    }
    p {
      padding: 0 0 10px 45px;
      color: #999999;
      cursor: pointer;
    }
  }
}
/* 公共样式 */
.m-auto {
  margin: auto;
}
</style>
